import React, { useEffect, useRef, useState } from 'react';
import './App.scss';
import Header from './Components/common-header/Header';
import Footer from './Components/common-footer/Footer';
import Hero from './Components/Hero/Hero';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import Section1 from './Components/Sections/Section1';
import Section2 from './Components/Sections/Section2';
import Section3 from './Components/Sections/Section3';
import Section4 from './Components/Sections/Section4';
import Section5 from './Components/Sections/Section5';
import Section6 from './Components/Sections/Section6';
import inline1D from './assets/inline-desktop.png';
import inline1M from './assets/inline-mobile.png';
import ctaArrow from './assets/arrow.svg';
import VideoLoop from './Components/VideoLoop/VideoLoop';

import CampaignFooter from './Components/CampaignFooter/CampaignFooter';
import Statistics from './Components/Statistics/Statistics';
import PhotoCarousel from './Components/PhotoCarousel/PhotoCarousel';
import Factbox from './Components/Factbox/Factbox';

gsap.registerPlugin(ScrollTrigger);

function App() {
  const section1 = useRef();
  const section2 = useRef();
  const inline1 = useRef();
  const headerRef = useRef();

  const [isTouchScreen, setIsTouchScreen] = useState(false);

  useEffect(() => {
    ScrollTrigger.matchMedia({
      '(max-width: 767px)': function () {
        const sections = [section1, section2];

        sections.forEach((panel, i) => {
          ScrollTrigger.create({
            trigger: panel.current,
            start: 'bottom bottom',
            pin: true,
            pinSpacing: false,
            scrub: 1
          });
        });
      }
    });
  }, []);

  useEffect(() => {
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: inline1.current,
        start: '10% bottom',
        end: 'top center',
        scrub: 1,
        once: true
      }
    });
    tl.to(inline1.current, { width: '100%', duration: 3 });
  }, []);

  useEffect(() => {
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: headerRef.current,
        start: 'bottom top',
        scrub: 1
      }
    });
    tl.to(headerRef.current, { y: -70, duration: 2 });
  }, []);

  return (
    <div
      className="app"
      onTouchStart={() => {
        setIsTouchScreen(true);
      }}
    >
      <div className="app__contents">
        <div className="section section1" ref={section1}>
          <Header headerRef={headerRef} clientName={"National Association of REALTORS®"} />
          <Hero />
          <Section1 />
          <VideoLoop />
          <Section2 />
        </div>

        <div className="section" ref={section2}>
          <div className="inline">
            <picture className="inline-photo" ref={inline1}>
              <source media="(min-width:461px)" srcSet={inline1D} />
              <source media="(max-width:460px)" srcSet={inline1M} />
              <img src={inline1D} alt="Family" />
            </picture>
          </div>

          <Section3 />

          <Section4 />
          <Statistics />

          <Section5 />
          <PhotoCarousel isTouchScreen={isTouchScreen} />
          <Section6 />
          <Factbox />
          <a
            href="https://www.realtor.com/thats-who-we-r/"
            target="_blank"
            rel="sponsored noopener"
            className="nar-href nar"
          >
            <div className="nar-href-button">
              Learn More <img src={ctaArrow} alt="arrow" className="nar-href-arrow" />
            </div>
          </a>
          <CampaignFooter />
          <Footer />
        </div>
      </div>
    </div>
  );
}

export default App;
